var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "mb-3 card" }, [
    _c("div", { staticClass: "card-header bg-secondary-3" }, [
      _vm.value.area.letter
        ? _c("div", { staticClass: "bg-green rounded letter-box mr-2" }, [
            _vm._v(" " + _vm._s(_vm._f("empty")(_vm.value.area.letter)) + " ")
          ])
        : _vm._e(),
      _vm._v(" Áreas de interés: "),
      _c("b", [
        _vm._v(" " + _vm._s(_vm._f("empty")(_vm.value.area.name)) + " "),
        _vm.isEvaluatedMainTasks ? _c("span", [_vm._v(":")]) : _vm._e()
      ]),
      _vm.value.area.description
        ? _c("span", [
            _vm._v(
              " " + _vm._s(_vm._f("empty")(_vm.value.area.description)) + " "
            )
          ])
        : _vm._e()
    ]),
    _c("div", { staticClass: "card-body bg-secondary-3" }, [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-md-1" },
          [
            _c("label", { staticClass: "data-name" }, [_vm._v("Puntuación:")]),
            _c("validation-provider", {
              ref: "score",
              attrs: {
                name: `Puntuación-${_vm.value.area.id}`,
                rules: "required|between:0,100"
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function({ errors, failedRules }) {
                    return [
                      _c("custom-input", {
                        ref: "scoreInput",
                        staticClass: "w-100",
                        attrs: {
                          "custom-error-msg": _vm.getErrorMessage(failedRules),
                          disabled: _vm.isReadOnly,
                          error: errors[0],
                          placeholder: "0-100"
                        },
                        on: { input: _vm.changeScore },
                        model: {
                          value: _vm.scoreText,
                          callback: function($$v) {
                            _vm.scoreText = $$v
                          },
                          expression: "scoreText"
                        }
                      })
                    ]
                  }
                }
              ])
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-md-2" },
          [
            _c("label", { staticClass: "data-name" }, [_vm._v("Prioridad:")]),
            _c("validation-provider", {
              attrs: { rules: "required" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function({ errors }) {
                    return [
                      _c("custom-radio", {
                        staticClass: "row",
                        attrs: {
                          "custom-error-msg": "El campo es requerido.",
                          disabled: _vm.isReadOnly,
                          error: errors[0],
                          "is-inline": "",
                          name: `has-priority-${_vm.value.area.id}`,
                          options: _vm.yesNotOptions
                        },
                        model: {
                          value: _vm.hasPriority,
                          callback: function($$v) {
                            _vm.hasPriority = $$v
                          },
                          expression: "hasPriority"
                        }
                      })
                    ]
                  }
                }
              ])
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-md" },
          [
            _c("label", { staticClass: "data-name" }, [
              _vm._v("Interpretación:")
            ]),
            _c("custom-input", {
              attrs: { disabled: _vm.isReadOnly },
              model: {
                value: _vm.model.comment,
                callback: function($$v) {
                  _vm.$set(_vm.model, "comment", $$v)
                },
                expression: "model.comment"
              }
            })
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }